/* unplugin-vue-components disabled */import script from "./YouthPlayerLink.vue?vue&type=script&lang=ts&setup=true"
export * from "./YouthPlayerLink.vue?vue&type=script&lang=ts&setup=true"

const __exports__ = script;

export default __exports__